export default {
    data: {
        audio: null,
    },
    methods: {
        getProperDate(message) {
            let ts = message.timestamp;
            let timezone = moment.tz.guess()
            let currentTimestamp = +moment();
            let diffInMinutes = (currentTimestamp - ts) / 1000 / 60;
            if (diffInMinutes <= 120) {
                return moment.tz(ts, timezone).fromNow();
            } else if (diffInMinutes <= (24 * 60)) {
                return moment.tz(ts, timezone).format("ddd, hA");
            } else {
                return moment.tz(ts, timezone).format('LLL');
            }

        },
        prettyDuration(duration) {
            if (Math.floor(duration / 60) > 0) {
                return Math.floor(duration / 60) + ' min ' + duration % 60 + ' sec';
            }
            else {
                return duration + ' sec';
            }
        },
        forwardMessage(sender, receiver, message, messageType) {
            var sender_id = sender.id.toString();
            var receiver_id = receiver.id.toString();
            var message = {
                type: messageType,
                message: message,
                senderId: sender_id,
                receiverId: receiver_id,
                timestamp: new Date().getTime(),
            };
            axios.post(process.env.MIX_MESSAGE_ENDPOINT, message);
            return message;
        },
    },
    eventLog(callDetails, eventType) {
        try {
            axios.post(process.env.MIX_LOGGER_ENDPOINT, { ...callDetails, ...{ 'userId': window.auth_user.id, 'timestamp': Date.now().toString(), 'event_type': eventType, 'platform': 'Web' } })
        } catch (e) {
            console.log('Event Log Failed');
            console.log(e);
        }
    }
}